import script from "./cl-no-data.vue?vue&type=script&lang=ts&setup=true"
export * from "./cl-no-data.vue?vue&type=script&lang=ts&setup=true"

import "./cl-no-data.vue?vue&type=style&index=0&id=51e123b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e123b3"]])

export default __exports__